import { PurchaseChannel } from "@redotech/redo-model/warranties";
import { ConditionTypeDetailsProps } from "@redotech/redo-return-ui/flows/return-flow/condition";
import {
  PurchaseChannelState,
  purchaseChannelToLabel,
} from "@redotech/redo-return-ui/flows/return-flow/condition-types/purchase-channel";
import { RedoListItem } from "@redotech/redo-web/arbiter-components/list/redo-list";
import { RedoSingleSelectDropdownInput } from "@redotech/redo-web/arbiter-components/select-dropdown/redo-single-select-dropdown-input";
import { memo, useMemo } from "react";

export const PurchaseChannelDetails = memo(function PurchaseChannelDetails({
  state,
  setState,
  disabled,
}: ConditionTypeDetailsProps<PurchaseChannelState>) {
  const channelOptions: RedoListItem<PurchaseChannel>[] = useMemo(
    () =>
      Object.values(PurchaseChannel).map((channel) => ({
        id: channel,
        value: channel,
        type: "text" as const,
        text: purchaseChannelToLabel[channel],
      })),
    [],
  );

  const selectedChannel = state.channel
    ? channelOptions.find((option) => option.value === state.channel)
    : undefined;

  return (
    <RedoSingleSelectDropdownInput
      disabled={disabled}
      flexGrow
      label="Purchase channel"
      options={channelOptions}
      optionSelected={({ item }) => setState({ ...state, channel: item.value })}
      placeholder="Select purchase channel..."
      selectedItem={selectedChannel}
      size="xs"
    />
  );
});
